import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { UsersBus } from '../models/UsersBus.model';
import { AuthResponse } from '../models/AuthResponse';

@Injectable()
export class AuthenticationService extends BaseService {

    private baseUrlProfileUrl: string;
    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Authentication/";
        this.baseUrlProfileUrl = this.rootUrl + "v1/userprofile/";
    }
    /**
    * @deprecated This postLogin is deprecated and will be removed in future versions.
    */
    postLogin(username: string, password: string): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('userid', username)
            .set('password', password);
        let url_call: string = this.baseUrl + 'Login/' + username + '/' + password + '/FG2';
        return this._http.post(url_call, '', { headers: headers });
    }
    /**
    * @deprecated This postCheckResetPassword is deprecated and will be removed in future versions.
    */
    postCheckResetPassword(resetId: string): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('resetid', resetId);

        let url_call: string = this.baseUrl + 'CheckResetPassword/' + resetId;
        return this._http.post(url_call, '', { headers: headers });
    }
    /**
    * @deprecated This postResetPassword is deprecated and will be removed in future versions.
    */
    postResetPassword(resetId: string, password: string): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('resetid', resetId)
            .set('password', password)
            .set('pw', password);
        //     let url_call: string = this.baseUrl + 'ResetPassword/' + resetId + '/' + password + '/FG2';
        let url_call: string = this.baseUrl + 'ResetPassword/' + resetId + '/' + password;
        return this._http.post(url_call, '', { headers: headers });
    }
    /**
    * @deprecated This ForgotPasswordMo is deprecated and will be removed in future versions.
    */
    ForgotPasswordMo(email: string): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('email', email);

        let url_call: string = this.baseUrl + 'ForgotPasswordMo/' + email;
        return this._http.post(url_call, '', { headers: headers });
    }
    /**
    * @deprecated This postAuthenticate is deprecated and will be removed in future versions.
    */
    postAuthenticate(userId: string, sessionId: string): Observable<any> {
        let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('Accept', 'application/json');
        let url_call: string = this.baseUrl + 'EMLogin/' + userId + '/' + sessionId;
        return this._http.post(url_call, { headers: headers });
    }

    userInfo(userId: string): Observable<any> {
        return this.get(this.baseUrl + 'UserInfoClean/' + userId);

    }
    /**
     * This is used for special scenarios where Managers wanted to remove a feature from a user and have it be immediately seen, without the user having to log out
     *
     * @param {string} userId
     * @memberof AuthenticationService
     */
    userFeatures(userId: string): Observable<any> {
        return this.get(this.baseUrl + 'UserFeatures/' + userId);
    }

    /**
     * Used in conjunction with Microsoft.Entra to get the user profile data after a successful login
     *
     * @param {string} email
     * @return {*}  {Observable<any>}
     * @memberof AuthenticationService
     */
    loginUserInfo(email: string, token: string): Observable<UsersBus> {
        return this.getWithHeaders(this.baseUrlProfileUrl + `LoginInfo/UserInfo/${email}`, { 'Authorization': 'Bearer ' + token });
    }

    refreshProfile(email: string): Observable<UsersBus> {
        return this.get(this.baseUrlProfileUrl + `LoginInfo/UserInfo/${email}`);
    }

    /**
     * Gets a legacy token used to call the Microservices that have not been ported over to SSO
     * @returns {AuthResponse}
     */
    getLegacyToken(): Observable<AuthResponse> {
        return this.get(this.baseUrl + `legacy/login`);
    }
}
